import { string, shape, number, arrayOf, bool } from 'prop-types';

const itineraryChangeRouteUserCustomerPropTypes = {
  id: number,
  firstName: string,
  lastName: string,
  idDocumentNumber: string,
  mobilePhone: string,
  email: string,
  fullName: string,
};

const itineraryChangeRouteUserPropTypes = {
  id: number,
  username: string,
  enabled: bool,
  verified: bool,
  blocked: bool,
  locale: string,
  customerId: number,
  customer: shape(itineraryChangeRouteUserCustomerPropTypes),
};

const itineraryChangeRouteRoutePropTypes = {
  id: number,
  name: string,
  description: string,
};

const itineraryChangeRouteDetailPropTypes = {
  id: number,
  itineraryChangeRouteId: number,
  itineraryId: number,
  oldRouteId: number,
  oldRoute: shape(itineraryChangeRouteRoutePropTypes),
  newRouteId: number,
  newRoute: shape(itineraryChangeRouteRoutePropTypes),
};

const itineraryChangeRouteBasicInformationPropTypes = {
  id: number.isRequired,
  userId: number,
  user: shape(itineraryChangeRouteUserPropTypes),
  comment: string,
  status: string,
  createDate: number,
  itineraryChangeRouteDetailList: arrayOf(
    shape(itineraryChangeRouteDetailPropTypes),
  ),
};

const itineraryChangeRouteBasicInformationDefaultProps = {
  userId: null,
  user: null,
  comment: null,
  status: null,
  createDate: null,
  itineraryChangeRouteDetailList: [],
};

export {
  itineraryChangeRouteBasicInformationPropTypes,
  itineraryChangeRouteBasicInformationDefaultProps,
  itineraryChangeRouteUserPropTypes,
  itineraryChangeRouteUserCustomerPropTypes,
  itineraryChangeRouteDetailPropTypes,
  itineraryChangeRouteRoutePropTypes,
};
